<!--
 * @Author: zhangxx 2425792130@qq.com
 * @Date: 2025-07-29 19:12:26
 * @LastEditors: zhangxx 2425792130@qq.com
 * @LastEditTime: 2025-07-31 19:17:26
 * @FilePath: \original-pc-toB-bookstores-red(ToB书城PC版红色)\src\views\readHome\readingHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="hotRead">
        <div class="topbg">
          <el-breadcrumb separator="/">
             <el-breadcrumb-item :to="{ path: '/read/readIndex' }">首页</el-breadcrumb-item>
             <el-breadcrumb-item>{{ cate_name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <h3 class="bigTitle">{{ cate_name }}</h3>
        
        <div class="book">
            <div class="book-item" v-for="(book, index) in list"
            :key="index">
                <div class="lefts">
                    <img :src="book.img_url" alt="" @click="setupBackRouterPath(book)">
                </div>
                <div class="right">
                    <h4 class="title" @click="setupBackRouterPath(book)">{{book.title}}</h4>
                    <p :title="book.author">{{book.author}}</p>
                    <div class="desc" v-html="book.desc||book.summary" v-if="book.desc||book.summary">
                    </div>
                </div>
            </div>
            <div v-if="loading" class="loading-more">加载中...</div>
            <!-- 无更多数据提示 -->
            <div v-if="noMore && list&& list.length > 0" class="no-more">
                已加载全部数据
            </div>
         </div>
         <BackTop
        :bottom="300"
        :right="backTopRight"
        class="boska"
        :class="
            isShowScrollBtn && isShowScrollBtn2
            ? 'showScrollBtn'
            : 'unShowScrollBtn'
        "
        on-click="scrollToTop()"
        >
        <div class="top" @click="scrollToTop">
            <div class="divg">
            <img
                style="width: 100%; height: 100%"
                src="../../assets/image/shang.png"
                alt=""
            />
            </div>
        </div>
        </BackTop>
    </div>
</template>

<script>
import ApiUrl from "../../js/apiUrl.js";
export default {
    name: 'bookRecommend',
    components: {
    },
    props: {
        parentScrollRef: {  // 父组件传递的滚动容器ref名称
            type: String,
            default: 'main'
        }
  },
    data() {
        return {
            cate_name: this.$route.query.cate_name, 
            token: localStorage.getItem("user_token")||'',
            menuid: this.$route.query.id,
            page_index: 1,
            page_size: 9,
            banben: 0,
            list: "",
            scrollContainer: null,  // 父组件的滚动容器DOM
            scrollDebounce: null,    // 防抖计时器
            finished: false,
            noMore: false, // 是否无更多数据
            loading: false,
            isShowScrollBtn: false,
            backTopRight: 200,
            isShowScrollBtn2: false,
            product_type: this.$route.query.product_type, 
        }
    },
    mounted() {
        var that = this;
        window.addEventListener("resize", function () {
            that.css_caculateBackTopRight();
        });
        this.css_caculateBackTopRight();
        // 1. 获取父组件的滚动容器（关键步骤）
        this.getParentScrollContainer();
        // 2. 初始化加载第一页数据
        this.getList();
        this.scrollParentToTop()
        
    },
    methods: {
        css_caculateBackTopRight() {
            var screenWidth = document.body.offsetWidth;
            if (screenWidth < 1200) {
                this.isShowScrollBtn2 = false;
            } else {
                this.isShowScrollBtn2 = true;
            }
            var right = (screenWidth - 1157) / 2 - 30;
            this.backTopRight = right || 200;
        },
        scrollToTop() {
            // 1. 获取父组件的滚动容器DOM
            const parentScrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!parentScrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref是否正确');
                return;
            }
            parentScrollContainer.scrollTop = 0;
        },
        scrollParentToTop() {
            // 1. 获取父组件的滚动容器DOM
            const parentScrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!parentScrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref是否正确');
                return;
            }
            parentScrollContainer.scrollTop = 0;
        },
        loadMore(){

        },
        // 1. 获取父组件的滚动容器DOM
        getParentScrollContainer() {
            this.scrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!this.scrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref或选择器');
                return;
            }
            // 监听父容器的滚动事件
            this.scrollContainer.addEventListener('scroll', this.handleParentScroll);
        },
        handleParentScroll() {
            // 防抖：300ms内只执行一次，避免频繁触发
            clearTimeout(this.scrollDebounce);
            this.scrollDebounce = setTimeout(() => {
                this.checkParentScrollBottom();
            }, 300);
        },
        checkParentScrollBottom() {
            if (!this.scrollContainer) return;
            const { scrollTop, clientHeight, scrollHeight } = this.scrollContainer;
            const threshold = 300;  // 距离底部200px时触发加载
            // 滚动到底部条件：当前滚动位置 + 容器高度 + 阈值 >= 内容总高度
            const isNearBottom = scrollTop + clientHeight + threshold >= scrollHeight;

            // 满足条件且非加载中、有更多数据，触发加载
            if (isNearBottom && !this.loading && !this.noMore) {
                this.page_index ++
                this.getList();
            }
            let scrollY = scrollTop;
            this.isShowScrollBtn = scrollY ;
        },
        //获取列表数据
        getList() {
            var that = this;
            let book_list_get
            if(that.product_type==='1'){
                book_list_get = ApiUrl.book_list_get
            }else{
                book_list_get = ApiUrl.column_list_get
            }
            if (that.loading || that.noMore) return;
            that.loading = true;
            this.Ajax(book_list_get,{
            token: this.token,
            id: this.menuid,
            product_type: this.product_type, //产品类型，1 电子书，2 鲜读
            page_index: this.page_index, //当前页码，从 1 开始
            page_size: this.page_size, //每页请求条数
            order_by: "update_at:desc" //排序方式，1 更新时间倒序，2 热门倒序
          }, function(data) {
                if (data) {
                    that.loading = false;
                    if(data.list.length>0){
                        that.list = [...that.list, ...data.list]
                        that.product_count = data.total;
                        // 判断是否有更多数据
                        that.noMore = that.list.length >= that.product_count;
                        if (that.list.length >= that.product_count || that.total < that.page_size) {
                            that.finished= true
                        }
                        that.totalPage = data.count;
                    }
                   
                    
                }else{
                    that.loading = false;
                    that.finished= false
                }
            });
        },
        //跳转·详情
        setupBackRouterPath(item){
            this.$router.push({
                    path: '/ebookdtl',
                    query: {
                        id: item.id,
                        token:this.token
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.hotRead{
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
}
.topbg {
    // width: 80%;
    margin: 20px auto;
}
.bigTitle {
    // width: 80%;
    margin: 20px auto;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-top: 45px;
}
.book {
    // width: 80%;
    margin: 10px auto;
            display: flex;
            margin-top: 30px;
            flex-wrap: wrap; // 允许换行
            gap: 22px;
            .book-item {
                display: flex;
                width: 32%;
                margin-bottom: 30px;
                background-color: #fff;
                border-radius: 10px;

                .lefts {
                    width: 150px;
                    cursor: pointer;
                    img {
                        width: 100%;
                        max-height: 100%;
                        border-radius: 10px; // 圆角效果
                    }
                }
                .right {
                    padding: 15px 17px;
                    max-width: calc( 100% - 150px);
                    .title {
                        margin-bottom: 15px;
                        box-sizing: border-box;
                        cursor: pointer;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        height: 48px;
                        overflow: hidden;
                    }
                    .desc {
                        margin-top: 8px;
                        box-sizing: border-box;
                        background-color: #f7f7f7;
                        height: 85px;
                        padding: 10px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                        padding-bottom:0
                    }
                    p{
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }
                }
            }
        }
        // 无更多数据样式
        .no-more {
            padding: 15px;
            text-align: center;
            color: #aeaeae;
            font-size: 14px;
            position: absolute;
            bottom:-7px;
            left:50%
        }
        .loading-more{
            padding: 20px;
            margin: 0 auto;
            color: #666;
            font-size: 14px;
        }
</style>